import { RadioGroup as RadioGroupAria, Text } from "react-aria-components";
import type { RadioGroupProps, ValidationResult } from "react-aria-components";
import React from "react";
import type { ReactNode } from "react";

import { cn } from "@/lib/helpers/cn";

import { FieldError2 } from "../atoms/FieldError";
import { Label2 } from "../atoms/Label";

export type RadioGroup2Props = {
  children?: ReactNode;
  classNameChildren?: string;
  classNameWrapper?: string;
  description?: string;
  errorMessage?: ((validation: ValidationResult) => string) | string;
  isDisabled?: boolean;
  isRequired?: boolean;
  label?: string;
} & Omit<RadioGroupProps, "children">;

export function RadioGroup2({
  children,
  classNameChildren,
  description,
  errorMessage,
  isInvalid,
  isRequired,
  label,
  ...props
}: RadioGroup2Props) {
  return (
    <RadioGroupAria className="tw:flex tw:flex-col tw:gap-3" {...props}>
      <Label2 isInvalid={isInvalid} isRequired={isRequired} label={label} />

      <div className={cn("tw:flex tw:flex-col tw:gap-2 tw:[&>label]:mb-0!", classNameChildren)}>
        {children}
      </div>

      {description && (
        <Text slot="description">
          <small>{description}</small>
        </Text>
      )}

      <FieldError2>{errorMessage}</FieldError2>
    </RadioGroupAria>
  );
}
